/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsluga paginacji listingu towarów
 *
 * @export
 * @class Pagination
 * @extends {Sort}
 */
import { Sort } from "./Sort.class";
import { AddToCart } from "../cart/AddToCart.class";

export class Pagination extends Sort {
	constructor() {
		super();
		this.pagination = null;
		this.paginationBtns = null;
		this.paginationNextBtn = null;
		this.paginationPrevBtn = null;
		this.paginationInputs = null;
		this.paginationSubmitBtns = null;
		this.actualPage = null;
		this.pageCount = null;
	}
	// ****************************************************************************************************
	// inicjalizacja paginacji
	// ****************************************************************************************************
	initPagination() {
		var that = this;
		that.pagination = $('.pagination');
		that.paginationBtns = $('.pagination-btn');
		that.paginationNextBtn = $('.paginationNextBtn');
		that.paginationPrevBtn = $('.paginationPrevBtn');
		that.paginationInputs = $('.pagination-page-input');
		that.paginationSubmitBtns = $('.btn-submit-pagination');
		if (that.pagination.length > 0) {
			that.actualPage = that.pagination.first().data('actual-page');
			that.pageCount = that.pagination.first().data('page-count');
		} else {
			that.actualPage = 1;
			that.pageCount = 1;
		}
		that.addPaginationBtnsClickEvent();
		that.addPaginationSubmitBtnsClickEvent();
		that.paginationInputs.on('keydown', function (e) {
			if (e.keyCode == 13) {
				$('#' + $('#' + e.currentTarget.id).data('submit-btn')).trigger('click');
			}
		});
	}
	// ****************************************************************************************************
	// dodanie do przyciskow next i prev eventu click
	// ****************************************************************************************************
	addPaginationBtnsClickEvent() {
		var that = this;
		if (that.paginationBtns.length > 0) {
			that.paginationBtns.each(function (i, e) {
				$(e).on('click', function (event) {
					event.preventDefault();
					if ($(e).attr('rel') == "next") {
						that.actualPage = that.actualPage + 1;
					}
					else {
						that.actualPage = that.actualPage - 1;
					}
					that.loadProductsListing();
				});
			});
		}
	}
	// ****************************************************************************************************
	// dodanie do przyciskow submit eventu click
	// ****************************************************************************************************
	addPaginationSubmitBtnsClickEvent() {
		var that = this;
		if (that.paginationSubmitBtns.length > 0) {
			that.paginationSubmitBtns.each(function (i, e) {
				$(e).on('click', function (event) {
					var input = $('#' + $(e).data('input-id'));
					var val = Number(input.val());
					if (val != that.actualPage && val <= that.pageCount && val > 0) {
						that.actualPage = val;
						that.loadProductsListing();
					}
					else {
						input.select();
					}
				});
			});
		}
	}
	// ****************************************************************************************************
	// przygotowanie parametru paginacji
	// ****************************************************************************************************
	preparePaginationParam(val) {
		var that = this;
		if (that.actualPage == 1) {
			return '';
		}
		else {
			return '/pg-' + that.actualPage;
		}
	}
	// ****************************************************************************************************
	// update linków po paginacji
	// ****************************************************************************************************
	updateHrefInLinksAfterPagination(linksObjList) {
		var that = this;
		var hrefSplit;
		linksObjList.each(function (i, e) {
			var href = $(e).attr('href');
			if ( href.includes('/pg-') ) {
				href = href.replace(/\/pg-\w+/, '/pg-' + that.actualPage);
			} else {
				if (href.includes('?')) {
					hrefSplit = href.split('?');
					href = hrefSplit[0] + '/pg-' + that.actualPage + '?' + hrefSplit[1];
				} else {
					href = href + '/pg-' + that.actualPage;
				}
			}

//console.log('href', href);
			if ( window.location.href.includes('/new') && $('#atnowosc-T').is(':checked') ){
				href = href.replace('/items', '/new');
			} else if ( window.location.href.includes('/new') && !$('#atnowosc-T').is(':checked') ){
				href = href.replace('/new', '/items');
			}
//console.log('href2', toolsObj.removeDefaultParameters(toolsObj.fixUrlOrder(href)));

			$(e).attr('href', toolsObj.removeDefaultParameters(toolsObj.fixUrlOrder(href)));
		});
	}
	// wczytanie listingu
	// ****************************************************************************************************
	loadProductsListing(options) {
		var that = this;
		var listingUrl, currentIndex;
		var defaults = {
			forceAjaxPageLoad: false,
			eventPopstate: false,
			listingType: false,
			preparedListingUrl: false
		};
		var settings = $.extend({}, defaults, options);
		if ( settings.eventPopstate ) {
			listingUrl = location.pathname;
			if (listingUrl.includes('/st-'))
				listingUrl = listingUrl + location.search;
			else
				listingUrl = listingUrl + '/st-0' + location.search; // wymusza zmiane sortu na serwerze
		} else {
			if ( settings.preparedListingUrl ) {
				listingUrl = that.prepareUpdateListingUrl(settings.preparedListingUrl);
//console.log('prepareUpdateListingUrl', settings.preparedListingUrl, listingUrl);
			} else
				listingUrl = that.prepareUpdateListingUrl();
		}
		toolsObj.ajaxLoadData({
			forceAjaxPageLoad: settings.forceAjaxPageLoad,
			url: listingUrl,
			cache: false, // dodane 4.03.2021
			target: '#productsList',
			loadingTarget: '#productsList',
			eventPopstate: settings.eventPopstate,
			sourceOfError: 'Pagination::loadProductsListing',
			onBeforeSend: function () {
				if (settings.listingType !== false) { // zmiana typu listingu po kliknieciu w btn
					toolsObj.setCookie('productsListingStyle', settings.listingType, 365);
				}
			},
			onComplete: function () {
				that.initChangeListingStyle();
				that.initSort();
				that.initPagination();
				that.initProductsPopovers();
				that.initProductsDropdowns();
				that.updateListingElementsOrder();
				that.updateListingElementsHeight();
				that.updateHrefInLinksAfterSort($('#searchedCategories a'));
				that.updateHrefInLinksAfterSort($('.languageLink'));
				that.updateHrefInLinksAfterPagination($('.languageLink'));
				that.updateHrefInLinksAfterFiltering($('.languageLink, #searchedCategories a'));
				if (settings.eventPopstate) {
					that.decodeFiltersFromUrlafterPopstate();
				}
				that.checkVisibilityClearFiltersBtn();

				let addToCartLocal = new AddToCart();
				addToCartLocal.init();

				that.initFavorites();
			}
		});
	}
	// ****************************************************************************************************
	// wczytanie listingu po popstate
	// ****************************************************************************************************
	prepareUpdateListingUrl(preparedUrl) {
		var that = this;
		var splitUrl, splitUrlSufix, splitUrlPrefix, url, baseUrl, urlSearch;

		if ( preparedUrl == undefined ) {
			baseUrl = location.pathname;
			urlSearch = location.search;
		} else {
			if ( preparedUrl.includes('?') ) {
				baseUrl = preparedUrl.split('?')[0];
				urlSearch = '?'+preparedUrl.split('?')[1];
			} else {
				baseUrl = preparedUrl;
				urlSearch = '';
			}
		}
//console.log('baseUrl0',baseUrl);
		if ( baseUrl.includes('/new/') && $('#atnowosc-T').is(':checked') ) {
			baseUrl = '/new';
			splitUrlSufix = '';
		} else if ( baseUrl.includes('/new/') && !$('#atnowosc-T').is(':checked') ) {
			baseUrl = '/items';
			splitUrlSufix = '';
		} else if ( baseUrl.includes('/items/atn-T') && !baseUrl.includes('/items/atn-T/') && $('#atnowosc-T').is(':checked') ) {
			baseUrl = '/new';
			splitUrlSufix = '';
		} else if (baseUrl.includes('/cat-')) {
			splitUrl = baseUrl.split('/cat-');
			baseUrl = splitUrl[0] + '/cat-';
			splitUrlSufix = '/k-' + splitUrl[1];
		} else if (baseUrl.includes('/items/')) {
			splitUrl = baseUrl.split('/items');
			baseUrl = splitUrl[0] + '/items/k-';
			splitUrlSufix = splitUrl[1];
		} else {
			splitUrlPrefix = baseUrl;
			splitUrlSufix = '';
		}

		if (splitUrlSufix.includes('/k-')) {
			splitUrl = splitUrlSufix.replace('/k-', '').split('/');
			baseUrl = baseUrl + splitUrl[0];
		}
//console.log('baseUrl1',baseUrl);

		url = baseUrl + that.prepareFilteringParams(urlSearch) + that.preparePaginationParam() + that.prepareSortParam() + urlSearch;
		url = url.replace('/k-/', '/');

		if ( url.includes('/new/') && $('#atnowosc-T').is(':checked') ) { //  && !url.includes('/new/st-0')
			url = url.replace('/atn-T', '');
			if ( url.includes('/at') ) {
				url = url.replace('/new/', '/items/atn-T/');
			}
		} else if (url.includes('/items/atn-T/st-0') ) {
			url = url.replace('/items/atn-T', '/new');
		}

//console.log('url',toolsObj.fixUrlOrder(url));
		return toolsObj.fixUrlOrder(url);
	}
	// ****************************************************************************************************
	// inicjalizacja porownywania
	// ****************************************************************************************************
	initCompare() {
		var that = this;
		that.addItemToCompareList = $('.addItemToCompare');
		that.removeItemFromCompareList = $('.removeItemFromCompare');
		that.compareModal = $('#modalCompareList');
		that.compareTargetContSelector = '#modalCompareList .modal-content';
		that.compareTargetCont = $(that.compareTargetContSelector);

		that.addItemToCompareList.each(function (i, e) {
			$(e).off().on('click', function (event) {
				event.stopPropagation();
				that.compareBtnClickEvent(e, true);
			});
		});

		that.removeItemFromCompareList.each(function (i, e) {
			$(e).off().on('click', function (event) {
				event.stopPropagation();

				if ( $(e).data("action") == "showModal" ) {
					that.compareModal.modal('show');
				} else {
					that.compareBtnClickEvent(e, false);
					that.compareModal.focus(); // modal traci fokus po usuwaniu
					//that.compareModal.modal('hide'); // wyłączone
				}
			});
		});

		that.initBtnShowCompareList();
	}
	// ****************************************************************************************************
	// obsługa kliknięcia w przycisk
	// ****************************************************************************************************
	compareBtnClickEvent(e, modeAdd) {
		var that = this;
		var id = $(e).data('target');
		var rabatKML = "N";
		var url, loadingCont;

		if (id.toLowerCase().indexOf("n") >= 0 || id.toLowerCase().indexOf("t") >= 0) {
			rabatKML = id.substring(id.length - 1, id.length);
			id = id.substring(0, id.length - 1);
		}

		if (that.compareTargetCont.find('.compareItem').length > 2 && modeAdd) { //
			toolsObj.showModalAlert(TXT_COMPARE_IS_FULL, TXT_COMPARE_PRODUCTS);
			return false;
		}

		if (modeAdd) {
			url = '/compare?current_action=ajax&akcja=dodaj&id=' + id + '&rabatKML=' + rabatKML;
			loadingCont = ($("#addItemToCompare"+id+rabatKML+" .loadingCont").length > 0)? $("#addItemToCompare"+id+rabatKML+" .loadingCont") : $(e);
		} else {
			url = '/compare?current_action=ajax&akcja=usun&id=' + id + '&rabatKML=' + rabatKML;
			loadingCont = ($("#removeItemFromCompare"+id+rabatKML+" .loadingCont").length > 0)? $("#removeItemFromCompare"+id+rabatKML+" .loadingCont") : $(e);
		}

		if (ROOT_CAT != 'false')
			url += "&ktId=" + encodeURIComponent(ROOT_CAT);

		toolsObj.ajaxLoadData({
			url: url,
			target: that.compareTargetContSelector,
			cache: false,
			method: 'POST',
			updateBrowserHistory: false,
			loadingMode: false,
			sourceOfError: 'Pagination::compareBtnClickEvent',
			onBeforeSend: function () {
				$(e).addClass('sending');
				loadingCont.children('.btnShowCompareList').fadeOut(0);
				loadingCont.prepend('<span id="spinner' + id + '" class="btnLoadingSpinner"><span class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></span></span>');
			},
			onSuccess: function () {
				// if (modeAdd) {
				// 	that.compareModal.modal('show');
				// } else {
				// 	if (that.ompareTargetCont.find('.compareItem').length < 1) {
				// 		that.compareModal.modal('hide');
				// 		// $('.dropdown-toggle').dropdown('hide');
				// 	}
				// }
			},
			onComplete: function () {
				if (modeAdd) { // warunek ze wzgl. na btn usun na liscie
					$('#addItemToCompare' + id + rabatKML).fadeOut(EFFECTS_SPEED, function () {
						$('#spinner' + id).remove();
						$('#removeItemFromCompare' + id + rabatKML).fadeIn(EFFECTS_SPEED, function(){
							that.initCompare();
						});
					}).removeClass('sending');
				} else {
					$('#removeItemFromCompare' + id + rabatKML).fadeOut(EFFECTS_SPEED, function () {
						$('#spinner' + id).remove();
						$('#addItemToCompare' + id + rabatKML).fadeIn(EFFECTS_SPEED, function() {
							that.initCompare();
						});
					}).removeClass('sending');
				}

				if ( that.compareTargetCont.find('.compareItem').length > 0 ) {
					that.compareModal.modal('show');
				}
			}
		});
	}

	// ****************************************************************************************************
	// inicjalizacja przycisków wywołujących listę z elementami do porownania
	// ****************************************************************************************************
	initBtnShowCompareList() {
		var that = this;

		$('.btnShowCompareList').each(function (i, e) {
			that.initSingleCompareBtn($(e));
		});
	}
	// ****************************************************************************************************
	// przycisk wywołujący listę porównania
	// ****************************************************************************************************
	initSingleCompareBtn(btn) {
		var that = this;

		btn.fadeIn(EFFECTS_SPEED);

		btn.off().on('click', function (event) {
			event.stopPropagation();
			that.compareModal.modal('show');
		}).on('mouseover', function(){
			$('.productCompareCont').addClass('noHover');
		}).on('mouseleave', function(){
			$('.productCompareCont').removeClass('noHover');
		});
	}

	// ****************************************************************************************************
	// inicjalizacja schowka
	// ****************************************************************************************************
	initFavorites(){
		var that = this;

		$('.addToCartForm').each(function (i, f) {
			that.initAddToClipboardBtn(f);
		});
	}
	// ****************************************************************************************************
	// Dodawanie do schowka
	// ****************************************************************************************************
	initAddToClipboardBtn(f) {
		var that = this;
		var btn = $('#addItemToClipboard' + f.id.value + f.rabatKML.value);
		var adding, saveQuantity, quantityInput;

		if (btn.length > 0) {
			if (f.rabatKML.value == 'T') {
				quantityInput = f.iloscKpl;
			}
			else {
				quantityInput = f.ilosc;
			}

			btn.off().on('click', function (event) {
				adding = (btn.data('action') == "add")? true : false;

				event.stopPropagation();

				if (!LOGGED) { // !LOGGED
					toolsObj.showModalAlert('<p class="m-0">' + TXT_CLIPBOARD_UNAVAILABLE + '</p>');
				}
				else {
					if (!$(this).hasClass('sending')) {
						if ( adding ) {
							f.akcja.value = 'dodajDoSchowka';
							$.ajax({
								url: '/cart?' + $(f).serialize(),
								method: 'POST',
								beforeSend: function () {
									saveQuantity = quantityInput.value;
									quantityInput.value = f.prec.value;
									$(btn).addClass('sending');
									$('<span id="clipboardSpinner' + f.id.value + '" class="btnLoadingSpinner"><span class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></span></span>').prependTo(btn.find('.loadingCont'));
								},
								success: function (data) {
									toolsObj.showModalAlert('<p class="m-0">' + data + '</p>');
								},
								complete: function () {
									btn.removeClass('sending');
									$('#clipboardSpinner' + f.id.value).remove();
									f.akcja.value = 'dodaj';
									quantityInput.value = saveQuantity;

									btn.find(".add").addClass("d-none");
									btn.find(".added").removeClass("d-none");
									btn.attr("title", TXT_REMOVED_FROM_CLIPBOARD_TITLE);
									btn.data('action', "remove");

									$.ajax({
										url: '/clipboard?current_action=ajax&getpkoid='+btn.data('id'),
										method: 'POST',
										success: function (data) {
											var pkoid = toolsObj.removeLetters(data);
											btn.data('pkoid',pkoid);
										}
									});
								}
							});
						} else {
							$.ajax({
								url: '/clipboard?akcja=usunZaznaczoneSchowka&idschowka'+btn.data('pkoid')+'=0',
								method: 'POST',
								beforeSend: function () {
									btn.addClass('sending');
									$('<span id="clipboardSpinner' + f.id.value + '" class="btnLoadingSpinner"><span class="spinner-border spinner-border-sm" role="status"><span class="sr-only">Loading...</span></span></span>').prependTo(btn.find('.loadingCont'));
								},
								success: function (data) {
									toolsObj.showModalAlert('<p class="m-0">'+TXT_REMOVED_FROM_CLIPBOARD+'<br><b>'+btn.data('kod')+'</b></p>');
								},
								complete: function () {
									btn.removeClass('sending');
									$('#clipboardSpinner' + f.id.value).remove();

									btn.find(".added").addClass("d-none");
									btn.find(".add").removeClass("d-none");
									btn.attr("title", TXT_ADD_FROM_CLIPBOARD_TITLE);
									btn.data('action', "add");
								}
							});
						}
					}
				}
			});

			return false;
		}
	}
	// ****************************************************************************************************
	// Dodawanie produktu do porownywarki
	// ****************************************************************************************************
	initAddToCompareBtn(f) {
		var that = this;
	}
	// ****************************************************************************************************
	// Usuwanie produktu do porownywarki
	// ****************************************************************************************************
	initRemoveFromCompareBtn(f) {
		var that = this;
	}
}